// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.res.js";
import * as Schema$LumiStore from "lumi-store/lib/es6/src/Schema.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Types$LumiDocuments from "./Types.res.js";

let jsonCodec = Jzon.object3(param => [
  param.sensorKey,
  param.measurement,
  param.changeTime
], param => ({
  TAG: "Ok",
  _0: {
    sensorKey: param[0],
    measurement: param[1],
    changeTime: param[2]
  }
}), Jzon.field("sensor", Document$LumiStore.Key.jsonCodec()), Jzon.field("measurement", Types$LumiDocuments.SensorMeasurement.jsonCodec), Jzon.field("changeTime", LumiDate.DateTime.jsonCodec));

let SensorState = {
  jsonCodec: jsonCodec
};

function occupied(sensorState) {
  return sensorState.measurement.free === 0;
}

function documentName(param) {
  
}

let Schema = Schema$LumiStore.Make({
  documentName: documentName,
  tag: "sensor-state",
  jsonCodec: jsonCodec,
  icon: "chart-line",
  readOnly: true
});

export {
  SensorState,
  occupied,
  Schema,
}
/* jsonCodec Not a pure module */
